import type { InstallmentPaymentIneligibilityReason } from '@massilia/contracts'

import { isInstallmentPaymentIneligibilityReason } from '@massilia/contracts'

/**
 * Extrait le motif de refus machine-lisible d'une erreur d'initiation de paiement 3/4x.
 *
 * Le serveur peut répondre 400 avec `{ reason: 'DEPARTURE_TOO_CLOSE' }` quand l'éligibilité
 * a changé entre l'affichage du formulaire et l'envoi. Le parsing est volontairement
 * défensif : n'importe quel autre corps de réponse (HTML d'un proxy, 500 sans body, message
 * texte…) doit simplement retourner `null` et laisser le message d'erreur générique parler.
 *
 * La reconnaissance des motifs est déléguée à `@massilia/contracts`, qui les déclare une
 * seule fois : recopier la liste ici la laisserait dériver en silence à chaque ajout.
 */
export function parseInstallmentIneligibilityReason(
  error: unknown
): InstallmentPaymentIneligibilityReason | null {
  if (typeof error !== 'object' || error === null) return null

  const response = (error as { response?: unknown }).response
  if (typeof response !== 'object' || response === null) return null

  const data = (response as { data?: unknown }).data
  if (typeof data !== 'object' || data === null) return null

  const reason = (data as { reason?: unknown }).reason

  return isInstallmentPaymentIneligibilityReason(reason) ? reason : null
}
